/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/notion" */ '@atlassian/logo-third-party/notion'
		).then((m) => m.NotionIcon),
	{ moduleId: '@atlassian/logo-third-party/notion' },
);

const LazyNotionIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-notion" */ './utils').then((m) => m.NotionIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/notion/icon' },
);

const LazyNotionSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-notion-search-result" */ './utils').then(
			(m) => m.NotionSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon' },
);

const LazyNotionIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-notion-borderless" */ './utils').then(
			(m) => m.NotionIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const NotionIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyNotionIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const NotionSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyNotionSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);

export const NotionIconBorderless: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyNotionIconBorderlessComponent />
		</Suspense>
	),
	OfficialIcon,
	'xxsmall',
);
